import { render, staticRenderFns } from "./ThucTeChi.vue?vue&type=template&id=28ed1e3f&"
import script from "./ThucTeChi.vue?vue&type=script&lang=js&"
export * from "./ThucTeChi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports